import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import reduxThunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'tachyons/css/tachyons.min.css';
import App from './components/App';
import ScrollToTop from './components/ScrollToTop';
import appReducer from './reducers';
import {
  fetchSite,
  listenToAuthChanges,
  watchAnswers,
  userOffline,
  userOnline,
} from './actions';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(appReducer, composeEnhancers(applyMiddleware(reduxThunk)));
firebase.initializeApp({
  apiKey: 'AIzaSyCpq92sWR8MxA9i-Gu35J5N9ATsWcxAij0',
  authDomain: 'automotive-events-quiz.firebaseapp.com',
  databaseURL: 'https://automotive-events-quiz.firebaseio.com',
  projectId: 'automotive-events-quiz',
  storageBucket: 'automotive-events-quiz.appspot.com',
  messagingSenderId: '1040457034650',
});

const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);

store.dispatch(fetchSite());
store.dispatch(listenToAuthChanges());
store.dispatch(watchAnswers());

const connectedRef = firebase.database().ref('.info/connected');

connectedRef.on('value', (snap) => {
  if (snap.val() === true) {
    store.dispatch(userOnline(new Date().getTime()));
  } else {
    store.dispatch(userOffline(new Date().getTime()));
  }
});

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </Router>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js